/**
 * Remove an element (if it exists) from an array.
 * @param {Array} arr - The array.
 * @param {*} element
 * @returns a copy of the array.
 */
export const Remove = (arr, element) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e === element);
    if (i !== -1) mutar.splice(i, 1);
    return mutar;
};

/**
 * Remove an element with the given key/value pair (if it exists) from an array.
 * @param {Array} arr - The array.
 * @param {string} k - key
 * @param {*} v - value
 * @returns a copy of the array.
 */
export const RemoveByKey = (arr, k, v) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e[k] === v);
    if (i !== -1) mutar.splice(i, 1);
    return mutar;
};

/**
 * Remove an element (if it exists) from an array.
 * @param {Array} arr - The array.
 * @param {string} id - The id
 * @returns a copy of the array.
 */
export const RemoveById = (arr, id, fieldname = 'id') => RemoveByKey(arr, fieldname, id);

/**
 * Replace or push an element to an existing array.
 * @param {Array} arr - the array
 * @param {*} element - the element to replace/push.
 * @returns a copy of the array.
 */
export const ReplaceOrPush = (arr, element) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e.element);
    i === -1 ? mutar.push(element) : mutar.splice(i, 1, element);
    return mutar;
};

/**
 * Replace or push an element to an existing array.
 * @param {Array} arr - the array
 * @param {*} element - the element to replace/push.
 * @returns a copy of the array.
 */
export const ReplaceOrPushById = (arr, element, field = 'id', allowMultiple = false) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e[field] === element[field]);
    if (allowMultiple) {
        mutar.push(element)
    } else {
        i === -1 ? mutar.push(element) : mutar.splice(i, 1, element);
    }
    return mutar;
};

/**
 * Replace or push an element to an existing array.
 * @param {Array} arr - the array
 * @param {*} element - the element to replace/push.
 * @param {string} property - the property you want to match against
 * @returns a copy of the array.
 */
export const ReplaceOrPushByProperty = (arr, element, property) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e[property] === element[property]);
    i === -1 ? mutar.push(element) : mutar.splice(i, 1, element);
    return mutar;
};

/**
 * Replace or push an element to the start of an existing array.
 * @param {Array} arr - the array
 * @param {*} element - the element to replace/push.
 * @returns a copy of the array.
 */
export const ReplaceOrPushToStartById = (arr, element) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e.id === element.id);
    i === -1 ? mutar.unshift(element) : mutar.splice(i, 1, element);
    return mutar;
};

/**
 * Replace or push an element to the start of an existing array.
 * @param {Array} arr - the array
 * @param {*} element - the element to replace/push.
 * @param {string} property - the property you want to match against
 * @returns a copy of the array.
 */
export const ReplaceOrPushToStartByProperty = (arr, element, property) => {
    const mutar = arr.slice(0);
    const i = mutar.findIndex((e) => e[property] === element[property]);
    i === -1 ? mutar.unshift(element) : mutar.splice(i, 1, element);
    return mutar;
};
